import React from 'react'
import {
  Divider,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from '@material-ui/core'

import { useStyles } from './FormCaracteristicas.styles'

export const FormCaracteristicas = (props) => {
  const { form } = props
  const classes = useStyles()

  return (
    <div>
      <Grid alignItems="center" container spacing={2}>
        <Grid item md={2} sm={4} xs={12}>
          <TextField
            fullWidth
            label="Altura (m)"
            name="altura"
            variant="outlined"
            onChange={form.handleChangeNumber}
            value={form.formState.values.altura || ''}
            multiline
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        <Grid item md={2} sm={4} xs={12}>
          <TextField
            fullWidth
            label="Peso (kg)"
            name="peso"
            variant="outlined"
            onChange={form.handleChangeNumber}
            value={form.formState.values.peso || ''}
            multiline
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
        
        <Grid item xs={12}>
          <Typography style={{ marginTop: '16px' }}>
            <b>Vestimenta superior</b>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Divider className={classes.divider} />
        </Grid>
        <Grid className={classes.fieldGroup} item xs={12}>
          <FormControl component="fieldset" fullWidth>
            <RadioGroup
              aria-label="vestimenta-superior"
              name="vestimentaSuperior"
              value={form.formState.values.vestimentaSuperior || null}
              onChange={form.handleChange}
              className={classes.radioGroup}
            >
              <FormControlLabel
                value="CAMISA DE MANGA CURTA"
                control={<Radio />}
                label="Camisa de manga curta"
              />
              <FormControlLabel
                value="CAMISA DE MANGA LONGA"
                control={<Radio />}
                label="Camisa de manga longa"
              />
              <FormControlLabel value="CAMISA REGADA" control={<Radio />} label="Camisa regata" />
              <FormControlLabel value="BLUSA" control={<Radio />} label="Blusa" />
              <FormControlLabel value="JAQUETA" control={<Radio />} label="Jaqueta" />
              <FormControlLabel value="SUTIÃ" control={<Radio />} label="Sutiã" />
              <FormControlLabel value="NENHUMA" control={<Radio />} label="Nenhuma" />
              <FormControlLabel value="OUTRO" control={<Radio />} label="Outro" />
              <FormControlLabel value="NÃO INFORMADO" control={<Radio />} label="Não informado" />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid className={classes.fieldGroup} item xs={12}>
          <TextField
            label="Outra vestimenta superior"
            name="outraVestimentaSuperior"
            variant="outlined"
            value={form.formState.values.outraVestimentaSuperior || ''}
            onChange={form.handleChange}
            disabled={form.formState.values.vestimentaSuperior !== 'OUTRO'}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography style={{ marginTop: '16px' }}>
            <b>Cor da vestimenta superior</b>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Divider className={classes.divider} />
        </Grid>
        <Grid className={classes.fieldGroup} item xs={12}>
          <FormControl component="fieldset" fullWidth>
            <RadioGroup
              aria-label="cor-vestimenta-inferior"
              name="corVestimentaSuperior"
              value={form.formState.values.corVestimentaSuperior || null}
              onChange={form.handleChange}
              className={classes.radioGroup}
            >
              <FormControlLabel value="PRETA" control={<Radio />} label="Preta" />
              <FormControlLabel value="BRANCA" control={<Radio />} label="Branca" />
              <FormControlLabel value="AZUL" control={<Radio />} label="Azul" />
              <FormControlLabel value="AMARELA" control={<Radio />} label="Amarela" />
              <FormControlLabel value="VERMELHA" control={<Radio />} label="Vermelha" />
              <FormControlLabel value="ESTAMPADA" control={<Radio />} label="Estampada" />
              <FormControlLabel value="NENHUMA" control={<Radio />} label="Nenhuma" />
              <FormControlLabel value="OUTRO" control={<Radio />} label="Outro" />
              <FormControlLabel value="NÃO INFORMADO" control={<Radio />} label="Não informado" />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid className={classes.fieldGroup} item xs={12}>
          <TextField
            label="Outra cor da vestimenta superior"
            name="outraCorVestimentaSuperior"
            variant="outlined"
            value={form.formState.values.outraCorVestimentaSuperior || ''}
            onChange={form.handleChange}
            disabled={form.formState.values.corVestimentaSuperior !== 'OUTRO'}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography style={{ marginTop: '16px' }}>
            <b>Vestimenta inferior</b>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Divider className={classes.divider} />
        </Grid>
        <Grid className={classes.fieldGroup} item xs={12}>
          <FormControl component="fieldset" fullWidth>
            <RadioGroup
              aria-label="vestimenta-inferior"
              name="vestimentaInferior"
              value={form.formState.values.vestimentaInferior || null}
              onChange={form.handleChange}
              className={classes.radioGroup}
            >
              <FormControlLabel value="CALÇA" control={<Radio />} label="Calça" />
              <FormControlLabel value="BERMUDA" control={<Radio />} label="Bermuda" />
              <FormControlLabel value="CALÇÃO" control={<Radio />} label="Calção" />
              <FormControlLabel value="CUECA" control={<Radio />} label="Cueca" />
              <FormControlLabel value="CALCINHA" control={<Radio />} label="Calcinha" />
              <FormControlLabel value="SHORT" control={<Radio />} label="Short" />
              <FormControlLabel value="SAIA" control={<Radio />} label="Saia" />
              <FormControlLabel value="NENHUM" control={<Radio />} label="Nenhum" />
              <FormControlLabel value="OUTRO" control={<Radio />} label="Outro" />
              <FormControlLabel value="NÃO INFORMADO" control={<Radio />} label="Não informado" />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid className={classes.fieldGroup} item xs={12}>
          <TextField
            label="Outra vestimenta inferior"
            name="outraVestimentaInferior"
            variant="outlined"
            value={form.formState.values.outraVestimentaInferior || ''}
            onChange={form.handleChange}
            disabled={form.formState.values.vestimentaInferior !== 'OUTRO'}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography style={{ marginTop: '16px' }}>
            <b>Cor da vestimenta inferior</b>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Divider className={classes.divider} />
        </Grid>
        <Grid className={classes.fieldGroup} item xs={12}>
          <FormControl component="fieldset" fullWidth>
            <RadioGroup
              aria-label="cor-vestimenta-inferior"
              name="corVestimentaInferior"
              value={form.formState.values.corVestimentaInferior || ''}
              onChange={form.handleChange}
              className={classes.radioGroup}
            >
              <FormControlLabel value="PRETA" control={<Radio />} label="Preta" />
              <FormControlLabel value="BRANCA" control={<Radio />} label="Branca" />
              <FormControlLabel value="AZUL" control={<Radio />} label="Azul" />
              <FormControlLabel value="AMARELA" control={<Radio />} label="Amarela" />
              <FormControlLabel value="VERMELHA" control={<Radio />} label="Vermelha" />
              <FormControlLabel value="ESTAMPADA" control={<Radio />} label="Estampada" />
              <FormControlLabel value="NENHUMA" control={<Radio />} label="Nenhuma" />
              <FormControlLabel value="OUTRO" control={<Radio />} label="Outro" />
              <FormControlLabel value="NÃO INFORMADO" control={<Radio />} label="Não informado" />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid className={classes.fieldGroup} item xs={12}>
          <TextField
            label="Outra cor da vestimenta inferior"
            name="outraCorVestimentaInferior"
            variant="outlined"
            value={form.formState.values.outraCorVestimentaInferior || ''}
            onChange={form.handleChange}
            disabled={form.formState.values.corVestimentaInferior !== 'OUTRO'}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <Typography style={{ marginTop: '16px' }}>
            <b>Tipo de calçado</b>
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Divider className={classes.divider} />
        </Grid>
        <Grid className={classes.fieldGroup} item xs={12}>
          <FormControl component="fieldset" fullWidth>
            <RadioGroup
              aria-label="tipo-calcado"
              name="tipoCalcado"
              value={form.formState.values.tipoCalcado || null}
              onChange={form.handleChange}
              className={classes.radioGroup}
            >
              <FormControlLabel value="TENIS" control={<Radio />} label="Tênis" />
              <FormControlLabel value="SAPATO" control={<Radio />} label="Sapato" />
              <FormControlLabel value="SANDALIA" control={<Radio />} label="Sandália" />
              <FormControlLabel value="MEIA" control={<Radio />} label="Meia" />
              <FormControlLabel value="NENHUM" control={<Radio />} label="Nenhum" />
              <FormControlLabel value="OUTRO" control={<Radio />} label="Outro" />
              <FormControlLabel value="NÃO INFORMADO" control={<Radio />} label="Não informado" />
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid className={classes.fieldGroup} item xs={12}>
          <TextField
            label="Outro tipo de calçado"
            name="outroTipoCalcado"
            variant="outlined"
            value={form.formState.values.outroTipoCalcado || ''}
            onChange={form.handleChange}
            disabled={form.formState.values.tipoCalcado !== 'OUTRO'}
            fullWidth
            InputLabelProps={{
              shrink: true,
            }}
          />
        </Grid>
      </Grid>
    </div>
  )
}
